import React from 'react';
import { CreateServiceModal } from './CreateServiceModal';
import { EditServiceModal } from './EditServiceModal';
import { ServiceDetailModal } from './ServiceDetailModal';

interface ServiceModalsProps {
  onCreateSuccess?: () => void;
  onEditSuccess?: () => void;
  onDeleteSuccess?: () => void;
}

const ServiceModals: React.FC<ServiceModalsProps> = ({
  onCreateSuccess,
  onEditSuccess,
  onDeleteSuccess,
}) => {
  return (
    <>
      <CreateServiceModal onSuccess={onCreateSuccess} />
      <EditServiceModal onSuccess={onEditSuccess} />
      <ServiceDetailModal onDeleteSuccess={onDeleteSuccess} />
    </>
  );
};

export default ServiceModals;
